import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { orgLoaderHandler } from "src/lib/orgLoaderHandler";
import { OrganizationProgramsPage } from "src/pages/OrganizationProgramsPage";
import { createOrganizationProgramsRepository } from "src/repositories/programs/createOrganizationProgramsRepository";

export const ORGANIZATION_PROGRAMS_DEFAULT_PAGE_SIZE = 10;

const searchSchema = z.object({
  q: z.string().optional(),
  p: z.coerce.number().optional(),
  ps: z.coerce.number().optional(),
});

export const Route = createFileRoute("/_auth/_coach/orgs/$slug/programs/")({
  component: OrganizationProgramsPage,
  validateSearch: searchSchema,
  ssr: true,
  loaderDeps: ({ search }) => ({
    pageIndex: search.p || 0,
    pageSize: search.ps || ORGANIZATION_PROGRAMS_DEFAULT_PAGE_SIZE,
    query: search.q || "",
  }),
  async loader({ context, deps, params }) {
    return orgLoaderHandler(
      { queryClient: context.queryClient, slug: params.slug },
      async ({ organization }) => {
        const programsRepository = createOrganizationProgramsRepository(
          organization.id,
        );
        await context.queryClient.query({
          ...programsRepository.listOptions(deps),
          staleTime: "static",
        });
        return { data: null };
      },
    );
  },
});
